import styled from "@emotion/styled";
import { Button, Link } from "@mui/material";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import { PageHeader } from "components/Common/Page";

export const ActionItemsPageContainer = styled.div({
	width: "100%",
	minWidth: 0,
	overflow: "hidden"
});

export const ActionItemsPageHeader = styled(PageHeader)({
	width: "100%",
	padding: "20px 32px"
});

export const ActionItemsPageContentContainer = styled.div({
	padding: "16px 20px",
	minWidth: 0
});

export const ActionItemsPageContent = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	minWidth: 0
}));

export const ActionItemsPageHelperText = styled.span(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const ActionItemsTableContainer = styled.div({
	overflowX: "auto",
	width: "100%",
	minWidth: 0,
	WebkitOverflowScrolling: "touch"
});

export const ActionItemDescription = styled.div({
	display: "flex",
	alignItems: "center",
	gap: 12
});

export const ActionItemWarningIcon = styled(WarningRoundedIcon)(({ theme }) => ({
	flexShrink: 0,
	color: theme.project.colors.semanticColors.error
}));

export const ActionItemActions = styled.div({
	display: "flex",
	alignItems: "center",
	gap: 16,
	whiteSpace: "nowrap"
});

export const ActionItemGoButton = styled(Button)({
	minWidth: 56,
	padding: "2px 12px"
}) as typeof Button;

export const ActionItemDismissLink = styled(Link)({
	cursor: "pointer",
	background: "none",
	border: "none",
	padding: 0,
	font: "inherit"
}) as typeof Link;
